// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"420":"component---src-pages-work-mdx","601":"component---src-pages-index-mdx","768":"component---src-pages-competencies-mdx"}[chunkId] || chunkId) + "-" + {"108":"65e45adb7ba723e10081","420":"6fd04dc10620a4b30a58","452":"0dc1492ad851e35ff0fd","601":"762a38a44bf219dc4da3","768":"9891968094faf4edf513"}[chunkId] + ".js";
};